import { Field, FormikErrors, FormikTouched } from "formik";
import React, { useEffect } from "react";
// import TextError from "./TextError";
import {
  customEmail,
  namePattern,
  noSpcialChar,
  pinFormat,
  posportVisa,
  postCode,
  yearRegex,
} from "../../../../utils/createValidationSchema";
// import { valudatesetformstatus } from "../../pages/onboarding/Onboarding";
import { FLKFormField, FLKInitialValues } from "../../../../store/onboarding/types";
import ErrorMessage from "../../Tooltips/ErrorMessage";
import "./SplitInput.scss";


interface SplitInputProps {
  name: string; // Name of the input field
  label?: string; // Optional label for the input
  type?: string; // Type of the input (e.g., "text", "number")
  className?: string; // Optional CSS class for styling
  allData: FLKFormField;
  completedPage?: boolean; // Whether the page is completed
  touched?: FormikTouched<FLKInitialValues>; // Touched fields from Formik
  maxlength?: number; // Maximum length of the input
  error?: FormikErrors<FLKInitialValues>; // Error messages for fields
  formik?: any; // Formik props for the form
  value?: string; // Current value of the input
  setFieldValue?: (field: string, value: any, shouldValidate?: boolean) => void; // Formik's setFieldValue function
  setFieldError?: (field: string, message: string | undefined) => void; // Formik's setFieldError function
  [key: string]: any; // Allow additional props
  doTFNFieldValidation?: boolean;
}

const SplitInput: React.FC<SplitInputProps> = (props) => {
  const {
    name,
    label,
    type,
    className,
    allData,
    completedPage,
    touched,
    maxlength,
    error,
    formik,
    value,
    setFieldValue,
    doTFNFieldValidation,
    selectedValue,
    ...rest
  } = props;
  const splitLength = Array(allData?.boxCount).fill(null);
  const currentYear = new Date().getFullYear();
  
  const isBetween = (num: number, min: number, max: number): boolean => {
    return num >= min && num <= max;
  };

  let errorMessage: string = "";
  // const isKeyPresent = touched?.hasOwnProperty(`${name}-0`);
  // if (isKeyPresent) {
  //   errorMessage = error ? error[`${name}-0`] || "" : "";
  // }
  // errorMessage = error && error[`${name}-0`] ? error[`${name}-0`] : "";
  errorMessage = error ? error[`${name}-0`] || "" : "";

  const finalUserInput = (splitLength: any) => {
    const values: any[] = [];
    splitLength.forEach((_: any, index: number) => {
      const element = document.getElementById(`${name}-${index}`);
      const fieldInputValue: any = element
        ? (element as HTMLInputElement).value
        : "";
      if (fieldInputValue !== "") {
        values.push(fieldInputValue);
      }
    });
    return values.join("");
  };

  const getFinalFullDate = () => {
    const dateFields = [
      { name: "text-1694675339-13", length: 2 },
      { name: "text-1694675339-14", length: 2 },
      { name: "text-1694675339-15", length: 4 }
    ];
    const dateValues = dateFields.map((field) => {
      const splitLength = Array(field?.length).fill(null);
      const dateValue: Array<string> = [];
      splitLength.forEach((_: any, index: number) => {
        const element = document.getElementById(`${field.name}-${index}`);
        const fieldInputValue: any = element
          ? (element as HTMLInputElement).value
          : "";
        if (fieldInputValue !== "") {
          dateValue.push(fieldInputValue);
        }
      });
      // if(dateValue?.length === 3){
        return dateValue.join("");
      // }else{
      //   return null;
      // }
      
      // const element = document.getElementById(field.name);
      // const fieldValue = element ? (element as HTMLInputElement).value : "";
      // return fieldValue.padStart(field.length, "0"); // Ensure proper length with leading zeros
    });

    const [day, month, year] = dateValues;
    if (day && month && year) {
      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      const currentYear = parseInt(year);
      const isLeapYear = (currentYear: number) => {
        return (currentYear % 4 === 0 && currentYear % 100 !== 0) || currentYear % 400 === 0;
      };

      if (
        parseInt(month) < 1 ||
        parseInt(month) > 12 ||
        parseInt(day) < 1 ||
        (parseInt(month) === 2 && parseInt(day) > (isLeapYear(parseInt(year)) ? 29 : 28)) ||
        ([4, 6, 9, 11].includes(parseInt(month)) && parseInt(day) > 30) ||
        parseInt(day) > 31
      ) {
        return null; // Return null if the date is invalid
      }

      return date; // Return as Date object
    }
    return null; // Return null if any field is missing
  };

  const fieldValidation = (fieldValue: any) => {
    let error: string = "";

    if(doTFNFieldValidation === false && allData?.pensionFieldName !== undefined && allData?.pensionFieldName !== null){
      if (allData?.pensionFieldName !== "") {
        return "";
      }
    }

    if (allData.validate) {
      if (
        allData.subtype === "text" ||
        allData.subtype === "email" ||
        allData.subtype === "number"
      ) {
        const finalUserValue = finalUserInput(splitLength);

        

        allData?.validations.forEach((element: any) => {
          if (allData.type === "text" || allData.type === "split-input") {
            // if (element.type === "required" && valudatesetformstatus !== "draft") {
            if (element.type === "required") {
              if (finalUserValue.length === 0) {
                error = element.params[0];
              }

              if (allData.tfnLabel === "DOB_yyyy") {
                const year = parseInt(finalUserValue);
                if (
                  !yearRegex.test(finalUserValue) ||
                  year < 1900 ||
                  year > currentYear
                ) {
                  error = element.params[0];
                }
              }

              if (["TFN 1", "TFN 2", "TFN 3"].includes(allData.tfnLabel ?? "")) {
                // if (finalUserValue.length !== 3 && valudatesetformstatus !== "draft") {
                if (finalUserValue !== "" && finalUserValue.length !== 3) {
                  error = `Fill all three ${allData.tfnLabel}`;
                }
              }
            } else if(element.type === "no_special_char"){
              if (finalUserValue.length >= 1) {
                if (!noSpcialChar.test(finalUserValue)) {
                  error = element.params[0];
                }
              }

            } else if (element.type === "pin_format") {
              // if(finalUserValue.length < 1 && valudatesetformstatus !== "draft"){
              if (finalUserValue.length < 1) {
                error = allData?.validations[0]?.params[0];
              } else if (
                finalUserValue.length > 1 &&
                !pinFormat.test(finalUserValue)
              ) {
                error = element.params[0];
              }
            } else if (element.type === "postcode") {
              // if(finalUserValue.length < 1 && valudatesetformstatus !== "draft"){
              if (finalUserValue.length < 1) {
                error = allData?.validations[0]?.params[0];
              } else if (
                !postCode.test(finalUserValue) &&
                finalUserValue.length > 1
              ) {
                error = element.params[0];
              }
            } else if (element.type === "passport_number") {
              if (!posportVisa.test(finalUserValue?.trim())) {
                error = element.params[0];
              }
            } else if (element.type === "characters") {
              // if (allData.pdfLabel !== "Othername" && valudatesetformstatus !== "draft") {
              if (allData.pdfLabel !== "Othername") {
                if (
                  finalUserValue.length > 0 &&
                  !namePattern.test(finalUserValue)
                ) {
                  error = element.params[0];
                }
              } else if (
                finalUserValue.length >= 1 &&
                !namePattern.test(finalUserValue) &&
                allData.pdfLabel === "Othername"
              ) {
                error = element.params[0];
              }
            } else if (element.type === "min-max") {
              if (isNaN(Number(finalUserValue))) {
                error = element.params[0];
              } else if (finalUserValue !== "") {
                if (
                  !isBetween(
                    parseInt(finalUserValue),
                    element?.min_value,
                    element?.max_value
                  )
                ) {
                  error = element.params[0];
                }
              }
            } else if (element.type === "number") {
              // Check if the input is a number
              if (finalUserValue.length >= 1) {
                if (isNaN(Number(finalUserValue))) {
                  error = element.params[0];
                }
              }

              if (allData.tfnLabel === "DOB_yyyy" && finalUserValue.length >= 1) {
                const year = parseInt(finalUserValue);
                if (
                  !yearRegex.test(finalUserValue) ||
                  year < 1900 ||
                  year > currentYear
                ) {
                  error = element.params[0];
                }
              }
            } else if(element?.type === "valid_date" && finalUserValue !== ""){
              const date = getFinalFullDate()
              const currentDate = new Date();
              if(date !== null && date !== undefined){
                if (date > currentDate) {
                  error = element.params[0];
                } else if (isNaN(date.getTime())) {
                  error = element.params[0];
                }
              }else {
                error = element.params[0];
              }

            }else if (element.type === "email") {
                if (element.type === "required" && !finalUserValue ) {
                    error = element.params[0];
                } else if (!finalUserValue && completedPage) {
                    if (element.type === "required") {
                        error = element.params[0];
                    }
                } else if (element.type === "email" && finalUserValue) {
                    if (!customEmail.test(finalUserValue)) {
                        error = element.params[0];
                    }
                }
            }
          }
          if (error) {
            return error;
          }
        });
      }
    }
    return error;
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    
    // Handle Tab key to skip to next split input field
    if (e.key === "Tab" && allData?.skipToNextFieldOnTab) {
      e.preventDefault();
      try {

        if(allData?.onTabNextFocusField){
          const nextFieldFirstInput = document.getElementById(`${allData.onTabNextFocusField}`) as HTMLInputElement;
          if (nextFieldFirstInput) {
            nextFieldFirstInput.focus();
            nextFieldFirstInput.select();
            return;
          }
        }
        const nextFieldName = getNextTabField(name);
        const nextFieldFirstInput = document.getElementById(`${nextFieldName}`) as HTMLInputElement;
        if (nextFieldFirstInput) {
          nextFieldFirstInput.focus();
          nextFieldFirstInput.select();
        }
      } catch (error) {
        // If getNextFieldName fails, allow default tab behavior
        e.preventDefault();
        const nextFocusableElement = document.querySelector(
          'input:not([disabled]), button:not([disabled]), textarea:not([disabled]), select:not([disabled])'
        ) as HTMLElement;
        nextFocusableElement?.focus();
      }
      return;
    }

    if (e.key === "Backspace" && !e.currentTarget.value && index > 0) {
      const currentInput = document.getElementById(`${name}-${index}`);
      if (currentInput && (currentInput as HTMLInputElement).value === "") {
        const prevInput = document.getElementById(`${name}-${index - 1}`);
        prevInput?.focus();
      } else if (currentInput) {
        (currentInput as HTMLInputElement).value = "";
      }
    }
  };

  const getNextFieldName = (name: string): string => {
    const parts = name.split("-");
    if (parts.length < 4) {
      throw new Error("Invalid field name format");
    }
    const currentIndex = parseInt(parts[2], 10);
    const nextIndex = currentIndex + 1;
    parts[2] = nextIndex.toString();
    parts[3] = "0"; // Reset the last part to 0
    return parts.join("-");
  };


  const getNextTabField = (name: string): string => {
    const parts = name.split("-");
    
    const currentIndex = parseInt(parts[2], 10);
    const nextIndex = currentIndex + 1;
    parts[2] = nextIndex.toString();
    parts[3] = "0"; // Reset the last part to 0
    return parts.join("-");
  };

  const moveToNextSplitInput = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    allData: any
  ) => {
    let { value } = e.currentTarget;
    value = value ? value.toUpperCase() : value;

    if (value && index <= splitLength.length - 1) {
      const currentInput = document.getElementById(
        `${name}-${index}`
      ) as HTMLInputElement;
      const nextInput = document.getElementById(
        `${name}-${index + 1}`
      ) as HTMLInputElement;

      if (currentInput) {
        currentInput.value = value.toUpperCase();
      }
      if (nextInput) {
        nextInput.focus();
        nextInput.select();
      } else if (allData?.moveToNext) {
        // Only for TFN and date of birth we need to move to next field.
        let nextFieldId = getNextFieldName(`${name}-${index}`);
        const nextBlockInput = document.getElementById(
          nextFieldId
        ) as HTMLInputElement;
        nextBlockInput?.focus();
        nextBlockInput?.select();
      }
    }
  };


  // Populate fields with selectedValue when it's provided (only on mount)
  useEffect(() => {
    if (selectedValue) {
      const valueStr = String(selectedValue);
      splitLength.forEach((_: any, index: number) => {
        const element = document.getElementById(`${name}-${index}`) as HTMLInputElement;
        if (element && element.value === "") {
          element.value = valueStr[index] ? valueStr[index].toUpperCase() : "";
          // Dispatch input event to update Formik state
          const event = new Event('input', { bubbles: true });
          element.dispatchEvent(event);
        }
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="class-name split-input-field">
        {splitLength.map((_: number | null, index: number) => (
            <div key={`${name}-${index}`}>
            <Field
              key={`${name}-${index}`}
              name={`${name}-${index}`}
              id={`${name}-${index}`}
              validate={fieldValidation}
              onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
              handleKeyDown(e, index)
              }
              placeholder={(() => {
              if (allData.pdfLabel === "DOB MM") {
                return "M";
              }
              if (allData.pdfLabel === "DOB DD") {
                return "D";
              }
              if (allData.pdfLabel === "DOB YYYY") {
                return "Y";
              }
              return "";
              })()}
              onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
              moveToNextSplitInput(e, index, allData);
              // Trigger validation immediately after input
              if (formik && formik.validateField) {
                formik.validateField(`${name}-${index}`);
              }
              }}
              className={""}
              maxLength={1}
              {...rest}
              disabled={allData?.disabled}
            />
            </div>
        ))}
      </div>
      <ErrorMessage message={errorMessage} />
    </>
  );
};

export default SplitInput;
